import React from "react";
import { Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 bg-[#F7F5F0]" data-testid="site-footer">
      <div className="container-x py-16">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <Zap size={20} className="text-[#C99B1A] fill-[#C99B1A]" strokeWidth={2.5} />
              <span className="font-display font-bold text-lg tracking-tight text-[#0A0A0A]">
                BARRAQ<span className="text-[#C99B1A]">.</span>AI
              </span>
            </div>
            <p className="text-black/55 text-sm leading-relaxed max-w-sm">
              Brilliant Speed. Radiant Logic. AI &amp; software systems engineered for teams who refuse to wait.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5" style={{ color: "rgba(10,10,10,0.5)" }}>
              Capabilities
            </div>
            <ul className="space-y-3 text-sm text-black/65">
              <li>AI CRM</li>
              <li>School Management</li>
              <li>Non-Profit AI CRM</li>
              <li>Mobile Apps</li>
              <li>AI Development</li>
              <li>AI Research</li>
              <li>Technology & AI Innovation</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5" style={{ color: "rgba(10,10,10,0.5)" }}>
              Studio
            </div>
            <ul className="space-y-3 text-sm text-black/65">
              <li>About Us</li>
              <li>Process</li>
              <li>Impact</li>
              <li>Contact</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5" style={{ color: "rgba(10,10,10,0.5)" }}>
              Reach
            </div>
            <ul className="space-y-3 text-sm text-black/65">
              <li>hello@barraq.ai</li>
              <li>US</li>
              <li>Worldwide</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-black/10 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="font-mono text-xs text-black/40">
            © {new Date().getFullYear()} BARRAQ.AI · ALL RIGHTS RESERVED
          </div>
          <div className="font-mono text-xs text-black/40 flex items-center gap-3">
            <span className="pulse-dot" />
            SYSTEMS NOMINAL · UPTIME 99.99%
          </div>
        </div>
      </div>
    </footer>
  );
}
